/* eslint-disable import/no-namespace */
import { URL } from '../../config'
import { getRequest } from '../../utils/httpRequest'
import * as types from './'

// define URLS
const userURL = URL.user

export function checkUserRole(role) {
  return function(getStore)
  {
    const url       = `${userURL}/inrole/${role}`
    const userToken = getStore().oidc.user.access_token
    const request = getRequest(url,'json',userToken)

    console.log(`checkUserRole usertoken`,userToken)

    return {
      type: types.user.GET_USER_ROLE,
      payload: request
    }
  }
}

export function setUserRole(isAdmin)
{
  const payload = {
    isAdmin
  }
  return {
    type: types.user.SET_USER_ROLE,
    payload: payload
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/action_user.js